import { ModifyStore, handleStoreState } from "Stores/RESTStore/CoreStore";
import { action, makeObservable, runInAction } from "mobx";
import { API } from "General/API";

export abstract class NewStore<T> extends ModifyStore<T> {
  constructor(listStore = undefined, identifier = undefined) {
    super(listStore, identifier);
    makeObservable(this, {
      save: action.bound,
    });
  }

  defaultData = {} as T;

  clear() {
    this.data = this.defaultData;
  }

  @handleStoreState()
  async save() {
    try {
      this.saveResult = await API.newData(this.url(), this.data);
      runInAction(() => {
        this.updateList();
      });
    } catch (err) {
      throw err;
    }
    return this.saveResult;
  }

  updateList() {
    if (this.listStore) {
      this.listStore.setItem(this.saveResult as T);
    }
  }
}
